import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { EnabledialogComponent } from '../enabledialog/enabledialog.component';
import { DisableComponent } from '../disable/disable.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { GlobalserviceService } from '../globalservice.service';
import { CodepopupComponent } from '../codepopup/codepopup.component';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'app-oduser-table',
  templateUrl: './oduser-table.component.html',
  styleUrls: ['./oduser-table.component.css']
})
export class ODuserTableComponent implements OnInit {
  datas: any;
  currentpage: number;
  stat;
  total: number = 0;
  p = this.currentpage;
  device: number = 0;
  animal: string;
  name: string;
  searchmeth: string = '';
  dev = 1;
  Userlist = [];
  Disablefn = true;
  DEPARTMENT
  searchlist: any;
  key: any;
  location: any;
  qrcode;searchval;

  constructor(public dialog: MatDialog, public snackBar: MatSnackBar, private router: Router, route: ActivatedRoute, public globalservice: GlobalserviceService ) {
  }

  ngOnInit() {
     //
    var Seraching = sessionStorage.getItem("search1");
    if(Seraching !== '') {
      this.searchmeth = Seraching;
      this.valuemeth(Seraching);
      console.log(Seraching);
      sessionStorage.removeItem('search1');
    } else {
      this.User_ODlist();
    }

 //    alert(Seraching);
     //
    this.stat = true;
    if (sessionStorage.page && sessionStorage.search == "") {
      this.p = sessionStorage.page;
    } else if (sessionStorage.search) {
      this.p = 1;
      sessionStorage.search = "";
    } else {

    }
    if (sessionStorage.page) {
      this.p = sessionStorage.page;
    } else {
      this.p = 1;
    }


  }
  onChange(value, gete, data, meth) {
    sessionStorage.setItem("employeid", gete);
    sessionStorage.setItem("odID", value);
    sessionStorage.setItem("deviceid", meth);

    if (value.checked == true) {
      this.device = 1;
      this.Enable_Dialog();
    } else {
      this.device = 0;
      this.Disable_Dialog();
    }
  }
  Enable_Dialog(): void {
    const dialogRef = this.dialog.open(EnabledialogComponent, {
      width: '250px',
      data: { animal: this.animal }
    });
  }

  Disable_Dialog(): void {
    const dialogRef = this.dialog.open(DisableComponent, {
      width: '250px',
      data: { animal: this.animal }
    });
  }
  pageChanged($event): void {
    this.p = $event;
    sessionStorage.page = this.p;
  }

  Route_Map(EmplyId, data) {
    if(!this.searchmeth){
      this.searchval = '';
    }
    else{
      this.searchval = this.searchmeth;
    }

    sessionStorage.setItem("search1", this.searchval);
    sessionStorage.page = this.p;
    sessionStorage.setItem("getID", EmplyId);
    sessionStorage.setItem("odID", data);
    localStorage.setItem("EMPID", EmplyId);
    this.router.navigate(['dashboard/On_DutyUser']);
  }
  User_ODlist() {
    this.globalservice.enableloader();
    this.globalservice.ODlist().subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.Userlist = responsedata['Data'];
        console.log(this.Userlist); debugger;
        var page = sessionStorage.page;
        delete sessionStorage.page;
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }


  codepopup(qrcode): void {
    const dialogRef = this.dialog.open(CodepopupComponent, {
      width: '150px',
      data: { animal: this.animal, qrcode: qrcode }
    });
  }
  valuemeth(data) {
    console.log(data); debugger;

    var level = {
      "Name": data
    }
 //   alert(level);
    this.globalservice.searchfilter(level).subscribe(responsedata => {
      if (responsedata.Success) {
        this.Userlist = responsedata['Data'];
        var page = sessionStorage.page;
        delete sessionStorage.page;
        console.log( this.Userlist) ;
      //  alert(this.Userlist);
      }
      else {
        this.User_ODlist();
      }

    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
  backward_map() {
    sessionStorage.removeItem('search1');
    sessionStorage.removeItem('filterloc');
   console.log(sessionStorage); debugger;
    this.router.navigate(['dashboard/OD_User']);
  }
}
